import { render, staticRenderFns } from "./teachersend.vue?vue&type=template&id=be02c096&scoped=true&"
import script from "./teachersend.vue?vue&type=script&lang=js&"
export * from "./teachersend.vue?vue&type=script&lang=js&"
import style0 from "./teachersend.vue?vue&type=style&index=0&id=be02c096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02c096",
  null
  
)

export default component.exports